/* Source: /app/components/auth/AuthShell.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { Outlet } from "@jac/runtime";
import { AuthHero } from "./AuthHero.js";
import { AuthParticles } from "./AuthParticles.js";
function AuthShell() {
  return __jacJsx("div", {"className": "jc-auth-shell"}, [__jacJsx("div", {"className": "jc-bg-orbs"}, []), __jacJsx(AuthParticles, {}, []), __jacJsx(AuthHero, {}, []), __jacJsx("div", {"className": "jc-auth-panel"}, [__jacJsx("div", {"className": "jc-float-wrap jc-slide-up"}, [__jacJsx(Outlet, {}, [])])])]);
}
/*jac:refresh-boundary*/;
export {AuthShell};
//# sourceMappingURL=AuthShell.js.map
